import PlaceholderPage from "../../../components/Placeholder/PlaceholderPage";

const VendorApplicationsPage = () => (
  <PlaceholderPage
    title="Vendor Applications"
    description="Incoming vendor applications will be managed here."
  />
);

export default VendorApplicationsPage;
